import { getDefaultData } from '../../data/product/get-default-data';
import { ProductLinks } from '../../data/product/product-links';
import {
  AllProductsButton,
  LinksColumnTitle,
  LinksContainer,
  LinksSubContainer,
  NavLink,
  SectionSubTitle,
  SectionTitle,
  TitleContainer,
} from '../HeaderSubmenuMobile.style';
import { navigation } from '@exploration/cms-constants';
import { Icon, svgIcons } from '@exploration/icons';
import { useTheme } from 'styled-components';

export const ProductMobileMenu = () => {
  const cmsData = getDefaultData();
  const { midwestColors: colors } = useTheme();
  return (
    <>
      <TitleContainer>
        <SectionTitle>
          {cmsData?.text?.[navigation.products_navigation_links.PRODUCTS_TITLE]}
        </SectionTitle>
        <SectionSubTitle>
          {
            cmsData?.text?.[
              navigation.products_navigation_links.PRODUCTS_DESCRIPTION
            ]
          }
        </SectionSubTitle>
        <AllProductsButton href={ProductLinks.bankingNavigationalLink.url}>
          {ProductLinks.bankingNavigationalLink.label}
          <Icon
            icon={svgIcons.arrowRight}
            colorPrimary={colors.sentimentNegativeStrong}
            height={19}
            width={19}
          />
        </AllProductsButton>
      </TitleContainer>
      <LinksContainer>
        <LinksSubContainer>
          <LinksColumnTitle>
            {
              cmsData?.text?.[
                navigation.products_navigation_links.banking_banking_title
              ]
            }
          </LinksColumnTitle>
          {ProductLinks.bankingLinks.map((bankingLink) => {
            return (
              <NavLink
                key={bankingLink.label}
                href={bankingLink.url}
                target={bankingLink.target}
              >
                {bankingLink.label}
              </NavLink>
            );
          })}
        </LinksSubContainer>
        <LinksSubContainer>
          <LinksColumnTitle>
            {
              cmsData?.text?.[
                navigation.products_navigation_links.banking_investments_title
              ]
            }
          </LinksColumnTitle>
          {ProductLinks.investmentLinks.map((investmentLink) => {
            return (
              <NavLink
                key={investmentLink.label}
                href={investmentLink.url}
                target={investmentLink.target}
              >
                {investmentLink.label}
              </NavLink>
            );
          })}
        </LinksSubContainer>
        <LinksSubContainer>
          <LinksColumnTitle>
            {
              cmsData?.text?.[
                navigation.products_navigation_links.banking_insurance_title
              ]
            }
          </LinksColumnTitle>
          {ProductLinks.investmentLinks.map((insuranceLink) => {
            return (
              <NavLink
                key={insuranceLink.label}
                href={insuranceLink.url}
                target={insuranceLink.target}
              >
                {insuranceLink.label}
              </NavLink>
            );
          })}
        </LinksSubContainer>
      </LinksContainer>
    </>
  );
};
